export const API_URL = '/api/'
export const BASE_COUNTRY = 'FI'
export const BASE_LANGUAGE = 'en'
export const ALERT_TIMEOUT = 5000
export const REQUEST_INTERVAL = 4000
export const REQUESTS_AMOUNT_LIMIT = 300
export const CONTACT_EMAIL = 'tilisy@enablebanking.com'
export const BROKER_ORIGIN = process.env.VUE_APP_BROKER_ORIGIN
export const SANDBOX = process.env.VUE_APP_SANDBOX
export const countriesNames = {
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DK: 'Denmark',
  EE: 'Estonia',
  ES: 'Spain',
  FI: 'Finland',
  FR: 'France',
  GR: 'Greece',
  HR: 'Croatia',
  HU: 'Hungary',
  IE: 'Ireland',
  IS: 'Iceland',
  IT: 'Italy',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  MT: 'Malta',
  NL: 'Netherlands',
  NO: 'Norway',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SI: 'Slovenia',
  SK: 'Slovakia',
  SE: 'Sweden',
  UK: 'United Kingdom'
}

export enum dateRanges {
  Year = 'year',
  HalfYear = 'half-of-year',
  Month = 'month',
  Week = 'week',
  Custom = 'custom'
}

export enum fileFormats {
  json = 'JSON',
  csv = 'CSV',
  pdf = 'PDF',
  excel = 'XLS'
}

export enum currencySymbols {
  eur = '€',
  usd = '$',
  rub = '₽'
}

export enum transactionStatuses {
  Complete = 'BOOK',
  Canceled = 'CNCL',
  Hold = 'HOLD',
  Other = 'OTHR',
  Pending = 'PDNG',
  Rejected = 'RJCT',
  Scheduled = 'SCHD'
}

export enum sessionStatuses {
  Invalid = 'INVALID',
  Pending = 'PENDING_AUTHORIZATION',
  Authorized = 'AUTHORIZED',
  Closed = 'CLOSED'
}

export enum exportStatuses {
  NotStarted = 'NOT_STARTED',
  Pending = 'IN_PROGRESS',
  Success = 'DONE',
  Failed = 'FAILED',
  Retry = 'RETRY'
}

export enum psuTypes {
  business = 'business',
  personal = 'personal'
}
